
import { CreateReconCustomerMappingPayload, ImportReconCustomerMappingResponse, ReconCustomerMapping, UpdateReconCustomerMappingPayload } from "../../../Types/CustomerMapType";
import axiosInstance from "../../../Utils/axiosInstance";

const LIST_URL = "/paper-app/recon-map-customer/";
const DETAIL_URL = "/paper-app/customer-mapping-detail/";
const BULK_URL = "/paper-app/customer-mapping-bulk-delete/";
const IMPORT_URL = "/paper-app/import-recon-customer-mapping/";
export const EXPORT_URL = "/paper-app/export-recon-customer-mapping-csv/"


export const fetchReconCustomerMappings = async (): Promise<
    ReconCustomerMapping[]
> => {
    const response = await axiosInstance.get(LIST_URL);
    return response.data;
};


export const createReconCustomerMapping = async (
    payload: CreateReconCustomerMappingPayload
): Promise<ReconCustomerMapping> => {
    const response = await axiosInstance.post(LIST_URL, payload);
    return response.data;
};


export const updateReconCustomerMapping = async (
    payload: UpdateReconCustomerMappingPayload
): Promise<ReconCustomerMapping> => {
    const { id, ...body } = payload;
    const response = await axiosInstance.put(
        `${DETAIL_URL}${payload.id}/`,
        body
    );
    return response.data;
};

export const importReconCustomerMappings = async (
    file: File
): Promise<ImportReconCustomerMappingResponse> => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axiosInstance.post<ImportReconCustomerMappingResponse>(
        IMPORT_URL,
        formData,
        {
            headers: { "Content-Type": "multipart/form-data" },
        }
    );
    return response.data;
};

export const deleteReconCustomerMapping = async (id: string): Promise<void> => {
    await axiosInstance.delete(`${DETAIL_URL}${id}/`);
};

export const bulkDeleteReconCustomerMappings = async (ids: string[]): Promise<void> => {
    await axiosInstance.delete(BULK_URL, { data: { ids } });
};